export const apiConstants = Object.freeze({
    login: {
        userSignIn: '/Account/ValidateUserCredentials',
        userSignup: '/Account/UserSignUp',
        getUserDetails: '/Account/UserDetailsGet',
        resetUserPassword: '/Account/UserResetPassword',
        validateUserEmail: '/Account/UserEmailValidate',
        resetPasswordEmailNotification: '/Account/ResetPasswordEmailNotification',
        validateToken: '/Account/ValidateToken',
        updateUserDetails: '/Account/UserDetailsUpdate',
        setUserInactiveStatus: '/Account/UserInactiveStatus',
        generateOneTimeLoginLink: '/Users/OneTimeLoginRequestLinkTokenGeneration',
        updatePassword: '/Account/PasswordUpdate',
        validateResetPasswordToken: '/Account/ResetPasswordTokenGenerationValidate',
        validateTokenAccessLink: '/Account/ValidateTokenAccessLink',
        getUserTypes: '/Account/UserTypesGet',
        countryCodesGet: '/Account/CountryCodesGet',
        passkeyRegisterBegin: '/AccountPasskey/PasskeyRegisterBegin',
        passkeyRegisterComplete: '/AccountPasskey/PasskeyRegisterComplete',
        passkeyLoginBegin: '/AccountPasskey/PasskeyLoginBegin',
        passkeyLoginComplete: '/AccountPasskey/PasskeyLoginComplete',
        passkeysList: '/AccountPasskey/PasskeysList',
        passkeyDelete: '/AccountPasskey/PasskeyDelete',
    },
    navBar: {

    },
    reports: {
        getPMRReportsPerId: '/MRReports/MRSitesReportsGetByReportID',
        getMRSItesMstr: '/MRSites/MRSitesMstrGet',
        getMRSitesReports: '/MRReports/MRSitesReportsGet',
        saveMRSitesCredentials: '/MRSitesCredentials/MRSitesCredentialsSave',
        saveMRSitesFetchAttempts: '/MRSitesFetchAttempts/MRSitesFetchAttemptsSave',
        getMRSitesFetchAttempts: 'MRSitesFetchAttempts/MRSitesFetchAttemptsGet',
        getMRSitesReportsByReportID: '/MRReports/MRSitesReportsGetByReportID',
        updateMRSItesReports: '/MRReports/MRSitesReportsUpdate',
        archiveMRSItesReports: '/MRReports/MRSItesReportsArchive',
        undoArchiveMRSItesReports: '/MRReports/MRSitesReportsArchiveUndo',
        getMRGroupsMstrlst: '/MRSites/MRGroupsMstrGet',
        getMRCategoriesMstr: '/MRSites/MRCategoriesMstrGet',
        documentSendEmail: '/Document/DocumentSendEmail',
        getReportLink: '/Document/ReportLinkGet',
        IinternalSharedReportsFromOthers: '/SharedReports/InternalSharedReportsFromOthers',
        InternalSharedReportsToOthers: '/SharedReports/InternalSharedReportsToOthers',
        InternalSharedReportsFromOthersComplete: '/SharedReports/InternalSharedReportsFromOthersComplete',
        ReportCategoriesGet: '/SharedReports/ReportCategoriesGet',
        SharedReportValidityGet: '/SharedReports/SharedReportValidityGet',
        sharedReportGeneratecodeGet: '/SharedReports/SharedReportGeneratecodeGet',
        shareReportQRCodeURL: '/SharedReports/ShareReportQRCodeURL',
        internalSharedReportRevoke: '/SharedReports/InternalSharedReportRevoke',
        mrSitesReportsGetByReportID: '/MRReports/MRSitesReportsGetByReportID',
        sharedReportsValidCodesGet: '/SharedReports/SharedReportsValidCodesGet',
        deleteReports: '/MRSites/MRReportsPathGetAndDelete?',
        archivereports: '/MRReports/MRSItesReportsArchive?',
        saveReportsDocument: 'Document/ReportDocumentSave',
        saveMRGroupsMstrInsert: 'MRSites/MRGroupsMstrInsert',
        InternalSharedReportAccessCheck: '/SharedReports/InternalSharedReportAccessCheck',
        InternalSharedReportSave: '/SharedReports/InternalSharedReportSave',
        InternalSharedReportUsersGet: '/SharedReports/InternalSharedReportUsersGet',
        InternalSharedReportUpdateStatus: '/SharedReports/InternalSharedReportUpdateStatus',
        InternalSharedReportOneTimeAccessCheck: '/MRReports/InternalSharedReportOneTimeAccessCheck',
        sendDocumentEmail: '/Document/DocumentSendEmail',
        getValidityOptions: '/SharedReports/ValidityOptionsMstrGet?',
        saveNoteforReport :'/MRReports/MRSitesReportNotesSave',
        getNotesatReports:"/MRReports/MRSitesReportNotesGet?"
    },
    users: {
        ProvidersGet: '/Users/ProvidersGet',
        HospitalsGet: '/Users/HospitalsGet',

    },
    admin: {
        getUserDetailsGet: '/Account/UserDetailsGet',
        getUserManagementDetailsGet: '/Admin/UsersManagementDetailsGet',
        getUsersManagementReportsGet: '/Admin/UsersManagementReportsGet',
        getGendersList: '/Admin/GendersListGet',
        getSubscriptionsList: '/Admin/SubscriptionsListGet',
        getRolesList: '/Admin/RolesListGet',
        getACMEEnquiryMessages: '/AcmehealthAI/GetACMEEnquiryMessages', //chatsGet
        usersManagementDetailsUpdate: "/Admin/UsersManagementDetailsUpdate",
        usersManagementArchive: "/Admin/UsersManagementArchive"

    },
    dashboard: {
        BulkMedicationCreate: '/MedicationTracker/BulkMedicationCreate',
        BulkMedicationDelete: '/MedicationTracker/BulkMedicationDelete',
        getMedicationatDashboard: "/MedicationTracker/MedicationGet",
        getMRSitesLabResults: '/LabResults/MRSitesLabResultsReportsGet',
        VitalsSave: '/Vitals/VitalsSave',
        MetabolicsSave: '/Vitals/MetabolicsSave',
        getVitals: '/Vitals/VitalsGet',
        getVitalsHistory: '/Vitals/VitalsGetHistory',
        getMetabolicsHistory: '/Vitals/MetabolicsGetHistory',
        getWidgets: '/Announcement/WidgetsGet',
        AddUserWidgets: '/Announcement/UsersWidgetsAdd',
        DeleteUserWidgets: '/Announcement/UsersWidgetsDelete',
        ProviderWidgetsManagementGet: '/Announcement/ProviderWidgetsManagementGet',
        ProviderWidgetsManagementMasterGet: '/Announcement/ProviderWidgetsManagementMasterGet',
        ProviderWidgetsManagementSortOrder: '/Announcement/ProviderWidgetsManagementSortOrder',
        getAllergies: '/Allergies/UsersAllergiesGet',
        createAllergies: '/Allergies/UsersAllergiesSave',
        deleteAllergies: '/Allergies/AllergiesDelete',
        createUserMedicalHistory: '/MedicalHistory/UsersMedicalHistorySave',
        getUserMedicalHistory: '/MedicalHistory/UsersMedicalHistoryGet',
        createVaccinations: '/Vaccination/VaccinationsSave',
        getVaccianations: '/Vaccination/VaccinationsGet',
        deleteVaccination: '/Vaccination/VaccinationsDelete',
        createUserAppointment: '/Appointment/UsersAppointmentSave',
        getUserAppointmentDetails: '/Appointment/UsersAppointmentsGet',
        deleteUserAppointmentDetails: '/Appointment/UsersAppointmentDelete',
        getProviderNotes: '/ProviderNotes/MRSitesProvidersNotesReportsGet',
        getLogUserMenuAnalytics: 'Users/LogUserMenuAnalytics',
        deleteVitalRecord: '/Vitals/VitalRecordDelete',
        deleteMetabolicsRecord: '/Vitals/MetabolicsRecordDelete',
        getLocations: '/Locations/LocationGet',
        addLocation: '/Locations/LocationSave',
        removeLocation: '/Locations/LocationsInactive',
        // getApplicationAnnouncements: '/Users/ApplicationAnnouncementsGet',


    },
    blog: {
        announcementsGet: '/announcement/AnnouncementsGet',
        announcementsSave: '/announcement/AnnouncementsSave',
        GetBlogCommentsReactions: '/announcement/GetBlogCommentsReactions',
        createBlogComment: '/announcement/CreateBlogComment',
        // "blogId": 10029,
        // "createdBy": 108,
        // "comments": "TEST",
        // "parentCommentId": 0
        announcementDelete: '/announcement/AnnouncementDelete',
        // "announcement_id": 10029,
        // "deleted_by": 108
        announcementsDelete: 'Announcements/AnnouncementDelete',
        announcementsCommentsSave: 'Announcements/AnnouncementsCommentsSave',
        announcementsCommentsGet: 'Announcements/AnnouncementsCommentsGet',
        CreateBlogReaction: 'Announcement/CreateBlogReaction',
        announcementsUpdate: 'Announcement/AnnouncementsUpdate',
        // getVitals: "PatientDashboard/VitalsGet",
        // getVitalsHistory: "PatientDashboard/VitalsGetHistory",
        // VitalsSave: 'PatientDashboard/VitalsSave',
    },
    spends: {
        getReceipts: '/Receipt/UsersMRSitesReceiptsGet',
        uploadReceipt: '/Receipt/ReceiptsSave',
        getReceiptsByID: '/Receipt/UsersMRSitesReceiptGetByID',
        archiveReceipts: '/Receipt/UsersMRSitesReceiptsArchive?',
        undoArchiveReceipts: '/Receipt/UsersMRSitesReceiptsArchiveUndo',
        deleteReceipts: '/Receipt/UsersMRSitesReceiptsDelete',
        saveReceipts: '/Receipt/ReceiptsSave',
    },

    riskCalculator: {
        getUserRiskAnalysisData: '/AcmehealthAI/GetUserRiskAnalysisData',
        extractRiskCalculatorData: '/AcmehealthAI/ExtractRiskCalculatorData',
    },
    notes: {
        getNotes: '/Notes/UserNotesGet?',
        createNote: '/Notes/UserNotesSave',
        stickyNotesSave: '/Users/StickyNotesSave',
        stickyNotesGet: '/Users/StickyNotesGet',
        stickyNotesDelete: '/Users/StickyNotesDelete',
        updateNote: '/Notes/UserNotesUpdate',
        deleteNote: '/Notes/UserNotesDelete',
    },
    profile: {
        profileUsersDetailsGet: '/Users/UsersDetailsGet',
        userPhotoUpload: '/Users/UserPhotoUpload',
        familyRelationsGet: '/FamilyAccounts/FamilyRelationsGet',
        familyMembersUsersGet: '/FamilyAccounts/FamilyMembersUsersGet',
        familyAccountsGetNew: '/FamilyAccounts/FamilyAccountsGetNew',
        userDetailsUpdate: '/Users/UserDetailsUpdate',
        familyAccountDelete: '/FamilyAccounts/FamilyAccountDelete',
        familyAccountCreate: '/FamilyAccounts/FamilyAccountCreate',
    },
    notifications: {
        NotificationsGet: '/Users/NotificationsGet',
        // http://192.168.1.5/PMRWebAPI/Users/NotificationsGet?UserID=108 
        notificationsRead: '/Users/NotificationsRead',
        // http://192.168.1.5/PMRWebAPI/Users/NotificationsRead 
        // {
        //     "UserID": 108,
        //     "NotificationID": 54382
        // }
        NotificationsReadAll: '/Users/NotificationsReadAll',
        // http://192.168.1.5/PMRWebAPI/Users/NotificationsReadAll 
        // { "UserID": 108, "is_important_notifications": false } 
        NotificationsShown: '/Users/NotificationsShown',
        FamilyAccountUpdateStatus: '/FamilyAccounts/FamilyAccountUpdateStatus',
        pushSubscriptions: '/PushSubscriptions/RegisterPushSubscription',
        notificationPreference: '/PushSubscriptions/SetNotificationPreference',
        getNotificationPreference: '/PushSubscriptions/GetNotificationPreference',

        // https://acmehealth.ai/PMRWebAPI/Users/NotificationsShown 
        // { 
        //   "UserID": 108, 
        //   "NotificationID": 64983 
        // } 
    },
    accessReports: {
        sharedReportsValidateCode: '/Account/SharedReportsValidateCode',
    },
    chat: {
        GetACMEEnquiryMessages: 'AcmehealthAI/GetACMEEnquiryMessages?',
        getReportsForMyChat: 'ChatBox/GetUserReportsForChats?',
        getAttachmentbyFileId: 'ChatBox/ChatBoxFilesGetByMessageID?',
        endChat:'AcmehealthAI/UpdateACMEChatSession',
        UpdateACMEReadMessage:'AcmehealthAI/UpdateACMEReadMessage'
    },
    trends: {
        trendsGet: '/LabResults/UsersLabResultsGet'
    },
    conversation: {
        getPatientConversationList: '/AcmehealthAI/GetACMEEnquiryMessageListByProvider?',
        getProvidermessages: '/AcmehealthAI/GetACMEEnquiryMessagesByProvider?',
        sendMessage: '/AcmehealthAI/ACMEEnquiryMessages',
        saveReportDocument: '/Document/CreateACMEEnquiryMessages'
    },
    emails: {
        sendEmail: '/MRReports/SaveEmailRequestAndSendZip',
        downloadMultipleReports: '/MRReports/MRSitesReportsZipWithGroups'

        
    },
    calendar: {
        getCalendarEventsCatgories: '/Reminder/ReminderCategoryListGet',
        getCalendarTimeEvents: '/Reminder/ReminderScheduleListGet',
        saveCalendarTimeEvent: "/Reminder/PatientReminderInsertUpdate",
        getCalenderEvents: "/Reminder/GetPatientReminders",
        deleteReminder: "/Reminder/PatientReminderInactiveStatusUpdate",
    },
    documentAssistant: {
        ask: '/DocumentAssistant/DocumentAssistantAsk',
        chatHistoryGet: '/DocumentAssistant/DocumentAssistantChatHistoryGet?',
        chatHistoryDelete: '/DocumentAssistant/DocumentAssistantChatHistoryDelete',
        chatSessionRename: '/DocumentAssistant/DocumentAssistantChatSessionRename',
        upload: '/DocumentAssistant/DocumentAssistantUpload',
    }

});

